import React from 'react';
import Image from 'components/Image';

const ErrorPage = () => {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <Image
          className="mt-4 object-contain w-[300px] h-[80px] mx-auto"
          src={'/images/logos/logo.png'}
          alt="Business Logo"
        />
        <Image
          className="mt-4 object-contain w-[300px] h-[300px] mx-auto"
          src={'/images/backgrounds/404.gif'}
          alt="Business Logo"
        />
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600">
          Sorry, we couldn’t find the page you’re looking for.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <a
            href="/"
            className="rounded-md bg-primary-main px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            Go back home
          </a>
          <a href="/" className="text-sm font-semibold text-gray-900 flex flex-col">
            <span aria-hidden="true">Contact support</span>
            <span aria-hidden="true">hello@doitpay.co</span>
          </a>
        </div>
      </div>
    </main>
  );
};

export default ErrorPage;
